import { useStoreFeatureCookie } from '@mnd-frontend/hooks';
import { getCookie, removeCookie, setCookie } from '@mnd-frontend/utils';
import i18next from 'i18next';
import { parse, stringify } from 'qs';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { locales } from '../../../../../../components/SetupProvider/i18n';
import { useUserLocaleAndTimezone } from '../../../../../../contexts/UserLocaleAndTimezoneContext';

const useAdminOverrides = () => {
  const { search } = useLocation();
  const { locale: userLocale } = useUserLocaleAndTimezone();

  useEffect(() => {
    const { locale, ...rest } = parse(search, { ignoreQueryPrefix: true });

    if (locale === undefined || typeof locale !== 'string') {
      return;
    }
    const currentValue = getCookie('locale');

    const shouldRemove = locale === '' || locale === 'false';

    if (locale === 'keys') {
      setCookie('locale', locale);
      i18next.changeLanguage(locale);
      return;
    }

    if ((shouldRemove && !currentValue) || currentValue === locale) {
      window.location.search = stringify(rest);
    } else if (shouldRemove) {
      removeCookie('locale');
      i18next.changeLanguage(userLocale);
      window.location.search = stringify(rest);
    } else if (locale in locales) {
      setCookie('locale', locale);
      i18next.changeLanguage(locale);
      window.location.search = stringify(rest);
    } else {
      console.error(`unsupported locale '${locale}' provided`);
    }
  }, [userLocale, search]);

  useStoreFeatureCookie({ queryString: search });

  useEffect(() => {
    const { FRONTEND_VERSION, version, ...rest } = parse(search, { ignoreQueryPrefix: true });
    const override = FRONTEND_VERSION ?? version;

    if (override === undefined || typeof override !== 'string') {
      return;
    }

    const currentValue = getCookie('frontend_version');

    if (override === '' || override === 'false') {
      removeCookie('frontend_version');
    } else if (override !== currentValue) {
      setCookie('frontend_version', override);
    }
    window.location.search = stringify(rest);
  }, [search]);
};

export default useAdminOverrides;
